export interface Ga4GeneralAnalyticsState {
    pageviewSent: boolean;
}

export interface AnalyticsState {
    events: any[];
    ga4: Ga4GeneralAnalyticsState;
    referredSent: boolean;
    searchOrigin: any;
}

export interface AnalyticsRelatedState {
    type: string;
}

export const analyticsInitialState: AnalyticsState = {
    events: [],
    ga4: {
        pageviewSent: false,
    },
    searchOrigin: null,
    referredSent: false,
};

export enum SearchRequestMethodName {
    search = 'search',
    query = 'query',
}
